export enum ReportListSorting {
    ReportName = 'ReportName',
    ExecutionDate = 'ExecutionDate',
    CreationDate = 'CreationDate',
}

export interface ReportsListToolbarProps {
    helpStripeId: string;
}
